// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (width > 769px){.bc-on-github{text-align:right}.bc-table{grid-template-columns:minmax(25%,max-content) repeat(var(--compat-browser-count),calc(75%/var(--compat-browser-count)))}.icon{--size:calc(1rem + 1px)}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
